import { render, staticRenderFns } from "./AdminPagination.vue?vue&type=template&id=3c8cf6be"
import script from "./AdminPagination.vue?vue&type=script&lang=js"
export * from "./AdminPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports